@for (page of pages(); let pageIndex = $index; let last = $last; track pageIndex) {
  <cfp-report-page
    [portfolioTitle]="customerName()"
    [translationKeyPrefix]="translationKeyPrefix()"
    [headerLogo]="headerLogo()"
    [chromeFooter]="chromeFooter()"
    [lastPage]="endsReport() && last && !trailingContentOnSeparatePage()"
    data-test="reportRoadmapBuildingPage"
  >
    @if (building().building) {
      <cfp-building-details-header
        [building]="buildingDetails()"
        [hideSelect]="true"
        [hideGoToAllBuildings]="true"
        [hideDeleteBuilding]="true"
        [canDownloadReport]="false"
        [buildingHeaderClass]="'col-auto'"
        [energyLabelRequirement]="energyLabelRequirement()"
        [onlyAllowNgContent]="true"
      >
        <cfp-report-building-energy-label-alert
          [energyLabels]="building().energyLabels"
          [objectType]="building().building.objectType"
          [showParkingWarning]="true"
        />
      </cfp-building-details-header>
    }

    @if (!hasPlannedMeasures() && hasCalculatedA()) {
      <cfp-alert [alertStyle]="'primary'" [hasAccent]="true" [classes]="'mb-5'" [iconTemplate]="iconTemplate">
        <h4>
          {{ translationKey('hasCalculatedA.title') | translate: { label: currentEnergyLabel()?.label } }}
        </h4>
        {{ translationKey('hasCalculatedA.body') | translate: { label: currentEnergyLabel()?.label } }}
      </cfp-alert>

      <ng-template #iconTemplate>
        <cfp-energy-label [energyLabel]="currentEnergyLabel()" [size]="'sm'" />
      </ng-template>
    }

    @if (pageIndex === 0 && building().building.ownershipStatus === OwnershipStatusDTO.PLANSTOSELLBEFORE2030) {
      <cfp-alert
        [alertStyle]="'primary'"
        [hasAccent]="true"
        [classes]="'mb-5'"
        [icon]="'circle-exclamation'"
        [iconSize]="'2x'"
        [iconStyle]="'primary'"
        [iconType]="'solid'"
        [dataTest]="'ownershipStatusAlert'"
      >
        <h4>{{ translationKey('ownershipStatus.sellBefore2030') | translate }}</h4>
        {{ building().building.ownershipStatusExplanation }}
      </cfp-alert>
    }

    @if (page.notes.length > 0) {
      @let notesTitle =
        page.notesPageNumber > 1
          ? `${('notes.title' | translate)} (${(translationKey('continued') | translate)})`
          : ('notes.title' | translate);

      <cfp-notes-list [notes]="page.notes" [title]="notesTitle" />
    }

    @if (page.plannedMeasures.length > 0) {
      <h1>
        {{ translationKey('roadmap.title') | translate }}

        @if (currentEnergyLabel() && improvedEnergyLabel()) {
          {{ 'roadmap.from' | translate }}
          <cfp-energy-label class="d-inline-block" [energyLabel]="currentEnergyLabel()" [size]="'sm'" />
          {{ 'roadmap.to' | translate }}
          <cfp-energy-label
            class="d-inline-block"
            [energyLabel]="improvedEnergyLabel() || currentEnergyLabel()"
            [size]="'sm'"
          />
          {{ page.plannedPageNumber > 1 ? ` (${(translationKey('continued') | translate)})` : '' }}
        }
      </h1>
      <cfp-report-building-roadmap-table
        [plannedMeasures]="page.plannedMeasures"
        [building]="building()"
        [portfolioBuildingsRoadmap]="portfolioBuildingsRoadmap()"
        [totalInvestments]="page.totalInvestments"
      />
      <cfp-report-buildings-legend
        [portfolioBuildingsRoadmap]="portfolioBuildingsRoadmap()"
      />
    }

    @if (page.implementedMeasures.length > 0) {
      <h1 [class.mt-5]="page.plannedMeasures.length > 0">
        {{ translationKey('measures.completed') | translate }}
        {{ page.implementedPageNumber > 1 ? ` (${(translationKey('continued') | translate)})` : '' }}
      </h1>
      <cfp-report-building-implemented-table
        [implementedMeasures]="page.implementedMeasures"
        [building]="building()"
      />
    }

    <div class="row mt-5">
      @if (showEnergyLabelHistory() && page.registeredEnergyLabels.length > 0) {
        <div class="col-6">
          <h1>{{ 'energyLabelHistory.title' | translate }}</h1>
          <cfp-energy-label-history-list [history]="page.registeredEnergyLabels" [labelGroup]="LabelGroupDTO.EPC" />
          <small class="text-muted d-flex align-items-center">
            <cfp-icon [icon]="'info-circle'" [classes]="'me-2 keep-original-icon'" />
            {{ 'energyLabelHistory.availableSince' | translate }}
          </small>
        </div>
      }

      @if (page.documentNames.length > 0 && isDocumentsTranslationLoaded()) {
        <div class="col-6">
          <h1>{{ 'documents.title' | translate }}</h1>
          <table class="table table-striped">
            <thead>
              <tr>
                <th>{{ 'documents.list.name' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              @for (documentName of page.documentNames; track $index) {
                <tr>
                  <td>{{ documentName }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>

    @if (page.embedTrailingContent) {
      @if (trailingContent(); as trailing) {
        <ng-container *ngTemplateOutlet="trailing; context: trailingContentContext(true)" />
      }
    }
  </cfp-report-page>
}

@if (trailingContentOnSeparatePage()) {
  @if (trailingContent(); as trailing) {
    <ng-container *ngTemplateOutlet="trailing; context: trailingContentContext(false)" />
  }
}
